/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import { PaymentModalities } from "../PaymentModalities";
import { VacancyDifference } from "../VacancyDifference/VacancyDifference";
import { EnteringTheBoxDifference } from "../VacancyDifference/EnteringTheBox/EnteringTheBoxDifference";
import { PaymentInfo } from "../Payment";

export interface Availability {
  flightTimeChanged: boolean;
  hasStops: boolean;
  vacancyOfferMismatchesFilters: boolean;
  vacancyId: string;
  debugVacancyFailed: string;
  vacancyOfferMismatchesFiltersParameterNames: string;
  status: Availability_VacancyStatus;
  type: Availability_VacancyType;
  paymentModalities?: PaymentModalities;
  vacancyDiff?: VacancyDifference;
  enteringTheBoxDiff?: EnteringTheBoxDifference;
  paymentTypeList: PaymentInfo[];
  tourOperatorMessages: string[];
}

export enum Availability_VacancyStatus {
  Unchecked = "Unchecked",
  Available = "Available",
  NotAvailable = "NotAvailable",
  Error = "Error",
  Pending = "Pending",
}

export function availability_VacancyStatusFromJSON(
  object: any
): Availability_VacancyStatus {
  switch (object) {
    case 0:
    case "Unchecked":
      return Availability_VacancyStatus.Unchecked;
    case 1:
    case "Available":
      return Availability_VacancyStatus.Available;
    case 2:
    case "NotAvailable":
      return Availability_VacancyStatus.NotAvailable;
    case 3:
    case "Error":
      return Availability_VacancyStatus.Error;
    case 4:
    case "Pending":
      return Availability_VacancyStatus.Pending;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum Availability_VacancyStatus"
      );
  }
}

export function availability_VacancyStatusToJSON(
  object: Availability_VacancyStatus
): string {
  switch (object) {
    case Availability_VacancyStatus.Unchecked:
      return "Unchecked";
    case Availability_VacancyStatus.Available:
      return "Available";
    case Availability_VacancyStatus.NotAvailable:
      return "NotAvailable";
    case Availability_VacancyStatus.Error:
      return "Error";
    case Availability_VacancyStatus.Pending:
      return "Pending";
    default:
      return "UNKNOWN";
  }
}

export function availability_VacancyStatusToNumber(
  object: Availability_VacancyStatus
): number {
  switch (object) {
    case Availability_VacancyStatus.Unchecked:
      return 0;
    case Availability_VacancyStatus.Available:
      return 1;
    case Availability_VacancyStatus.NotAvailable:
      return 2;
    case Availability_VacancyStatus.Error:
      return 3;
    case Availability_VacancyStatus.Pending:
      return 4;
    default:
      return 0;
  }
}

export enum Availability_VacancyType {
  UnknownVacancyType = "UnknownVacancyType",
  AutoVacancy = "AutoVacancy",
  ManualVacancy = "ManualVacancy",
  Upsell = "Upsell",
  AlternativeFlight = "AlternativeFlight",
  EnteringTheBox = "EnteringTheBox",
}

export function availability_VacancyTypeFromJSON(
  object: any
): Availability_VacancyType {
  switch (object) {
    case 0:
    case "UnknownVacancyType":
      return Availability_VacancyType.UnknownVacancyType;
    case 1:
    case "AutoVacancy":
      return Availability_VacancyType.AutoVacancy;
    case 2:
    case "ManualVacancy":
      return Availability_VacancyType.ManualVacancy;
    case 3:
    case "Upsell":
      return Availability_VacancyType.Upsell;
    case 4:
    case "AlternativeFlight":
      return Availability_VacancyType.AlternativeFlight;
    case 5:
    case "EnteringTheBox":
      return Availability_VacancyType.EnteringTheBox;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum Availability_VacancyType"
      );
  }
}

export function availability_VacancyTypeToJSON(
  object: Availability_VacancyType
): string {
  switch (object) {
    case Availability_VacancyType.UnknownVacancyType:
      return "UnknownVacancyType";
    case Availability_VacancyType.AutoVacancy:
      return "AutoVacancy";
    case Availability_VacancyType.ManualVacancy:
      return "ManualVacancy";
    case Availability_VacancyType.Upsell:
      return "Upsell";
    case Availability_VacancyType.AlternativeFlight:
      return "AlternativeFlight";
    case Availability_VacancyType.EnteringTheBox:
      return "EnteringTheBox";
    default:
      return "UNKNOWN";
  }
}

export function availability_VacancyTypeToNumber(
  object: Availability_VacancyType
): number {
  switch (object) {
    case Availability_VacancyType.UnknownVacancyType:
      return 0;
    case Availability_VacancyType.AutoVacancy:
      return 1;
    case Availability_VacancyType.ManualVacancy:
      return 2;
    case Availability_VacancyType.Upsell:
      return 3;
    case Availability_VacancyType.AlternativeFlight:
      return 4;
    case Availability_VacancyType.EnteringTheBox:
      return 5;
    default:
      return 0;
  }
}

function createBaseAvailability(): Availability {
  return {
    flightTimeChanged: false,
    hasStops: false,
    vacancyOfferMismatchesFilters: false,
    vacancyId: "",
    debugVacancyFailed: "",
    vacancyOfferMismatchesFiltersParameterNames: "",
    status: Availability_VacancyStatus.Unchecked,
    type: Availability_VacancyType.UnknownVacancyType,
    paymentModalities: undefined,
    vacancyDiff: undefined,
    enteringTheBoxDiff: undefined,
    paymentTypeList: [],
    tourOperatorMessages: [],
  };
}

export const Availability = {
  encode(
    message: Availability,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.flightTimeChanged === true) {
      writer.uint32(48).bool(message.flightTimeChanged);
    }
    if (message.hasStops === true) {
      writer.uint32(56).bool(message.hasStops);
    }
    if (message.vacancyOfferMismatchesFilters === true) {
      writer.uint32(88).bool(message.vacancyOfferMismatchesFilters);
    }
    if (message.vacancyId !== "") {
      writer.uint32(10).string(message.vacancyId);
    }
    if (message.debugVacancyFailed !== "") {
      writer.uint32(66).string(message.debugVacancyFailed);
    }
    if (message.vacancyOfferMismatchesFiltersParameterNames !== "") {
      writer
        .uint32(98)
        .string(message.vacancyOfferMismatchesFiltersParameterNames);
    }
    if (message.status !== Availability_VacancyStatus.Unchecked) {
      writer
        .uint32(16)
        .int32(availability_VacancyStatusToNumber(message.status));
    }
    if (message.type !== Availability_VacancyType.UnknownVacancyType) {
      writer.uint32(24).int32(availability_VacancyTypeToNumber(message.type));
    }
    if (message.paymentModalities !== undefined) {
      PaymentModalities.encode(
        message.paymentModalities,
        writer.uint32(74).fork()
      ).ldelim();
    }
    if (message.vacancyDiff !== undefined) {
      VacancyDifference.encode(
        message.vacancyDiff,
        writer.uint32(82).fork()
      ).ldelim();
    }
    if (message.enteringTheBoxDiff !== undefined) {
      EnteringTheBoxDifference.encode(
        message.enteringTheBoxDiff,
        writer.uint32(106).fork()
      ).ldelim();
    }
    for (const v of message.paymentTypeList) {
      PaymentInfo.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.tourOperatorMessages) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Availability {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAvailability();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 6:
          message.flightTimeChanged = reader.bool();
          break;
        case 7:
          message.hasStops = reader.bool();
          break;
        case 11:
          message.vacancyOfferMismatchesFilters = reader.bool();
          break;
        case 1:
          message.vacancyId = reader.string();
          break;
        case 8:
          message.debugVacancyFailed = reader.string();
          break;
        case 12:
          message.vacancyOfferMismatchesFiltersParameterNames = reader.string();
          break;
        case 2:
          message.status = availability_VacancyStatusFromJSON(reader.int32());
          break;
        case 3:
          message.type = availability_VacancyTypeFromJSON(reader.int32());
          break;
        case 9:
          message.paymentModalities = PaymentModalities.decode(
            reader,
            reader.uint32()
          );
          break;
        case 10:
          message.vacancyDiff = VacancyDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 13:
          message.enteringTheBoxDiff = EnteringTheBoxDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 4:
          message.paymentTypeList.push(
            PaymentInfo.decode(reader, reader.uint32())
          );
          break;
        case 5:
          message.tourOperatorMessages.push(reader.string());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Availability {
    return {
      flightTimeChanged: isSet(object.flightTimeChanged)
        ? Boolean(object.flightTimeChanged)
        : false,
      hasStops: isSet(object.hasStops) ? Boolean(object.hasStops) : false,
      vacancyOfferMismatchesFilters: isSet(object.vacancyOfferMismatchesFilters)
        ? Boolean(object.vacancyOfferMismatchesFilters)
        : false,
      vacancyId: isSet(object.vacancyId) ? String(object.vacancyId) : "",
      debugVacancyFailed: isSet(object.debugVacancyFailed)
        ? String(object.debugVacancyFailed)
        : "",
      vacancyOfferMismatchesFiltersParameterNames: isSet(
        object.vacancyOfferMismatchesFiltersParameterNames
      )
        ? String(object.vacancyOfferMismatchesFiltersParameterNames)
        : "",
      status: isSet(object.status)
        ? availability_VacancyStatusFromJSON(object.status)
        : Availability_VacancyStatus.Unchecked,
      type: isSet(object.type)
        ? availability_VacancyTypeFromJSON(object.type)
        : Availability_VacancyType.UnknownVacancyType,
      paymentModalities: isSet(object.paymentModalities)
        ? PaymentModalities.fromJSON(object.paymentModalities)
        : undefined,
      vacancyDiff: isSet(object.vacancyDiff)
        ? VacancyDifference.fromJSON(object.vacancyDiff)
        : undefined,
      enteringTheBoxDiff: isSet(object.enteringTheBoxDiff)
        ? EnteringTheBoxDifference.fromJSON(object.enteringTheBoxDiff)
        : undefined,
      paymentTypeList: Array.isArray(object?.paymentTypeList)
        ? object.paymentTypeList.map((e: any) => PaymentInfo.fromJSON(e))
        : [],
      tourOperatorMessages: Array.isArray(object?.tourOperatorMessages)
        ? object.tourOperatorMessages.map((e: any) => String(e))
        : [],
    };
  },

  toJSON(message: Availability): unknown {
    const obj: any = {};
    message.flightTimeChanged !== undefined &&
      (obj.flightTimeChanged = message.flightTimeChanged);
    message.hasStops !== undefined && (obj.hasStops = message.hasStops);
    message.vacancyOfferMismatchesFilters !== undefined &&
      (obj.vacancyOfferMismatchesFilters =
        message.vacancyOfferMismatchesFilters);
    message.vacancyId !== undefined && (obj.vacancyId = message.vacancyId);
    message.debugVacancyFailed !== undefined &&
      (obj.debugVacancyFailed = message.debugVacancyFailed);
    message.vacancyOfferMismatchesFiltersParameterNames !== undefined &&
      (obj.vacancyOfferMismatchesFiltersParameterNames =
        message.vacancyOfferMismatchesFiltersParameterNames);
    message.status !== undefined &&
      (obj.status = availability_VacancyStatusToJSON(message.status));
    message.type !== undefined &&
      (obj.type = availability_VacancyTypeToJSON(message.type));
    message.paymentModalities !== undefined &&
      (obj.paymentModalities = message.paymentModalities
        ? PaymentModalities.toJSON(message.paymentModalities)
        : undefined);
    message.vacancyDiff !== undefined &&
      (obj.vacancyDiff = message.vacancyDiff
        ? VacancyDifference.toJSON(message.vacancyDiff)
        : undefined);
    message.enteringTheBoxDiff !== undefined &&
      (obj.enteringTheBoxDiff = message.enteringTheBoxDiff
        ? EnteringTheBoxDifference.toJSON(message.enteringTheBoxDiff)
        : undefined);
    if (message.paymentTypeList) {
      obj.paymentTypeList = message.paymentTypeList.map((e) =>
        e ? PaymentInfo.toJSON(e) : undefined
      );
    } else {
      obj.paymentTypeList = [];
    }
    if (message.tourOperatorMessages) {
      obj.tourOperatorMessages = message.tourOperatorMessages.map((e) => e);
    } else {
      obj.tourOperatorMessages = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<Availability>): Availability {
    const message = createBaseAvailability();
    message.flightTimeChanged = object.flightTimeChanged ?? false;
    message.hasStops = object.hasStops ?? false;
    message.vacancyOfferMismatchesFilters =
      object.vacancyOfferMismatchesFilters ?? false;
    message.vacancyId = object.vacancyId ?? "";
    message.debugVacancyFailed = object.debugVacancyFailed ?? "";
    message.vacancyOfferMismatchesFiltersParameterNames =
      object.vacancyOfferMismatchesFiltersParameterNames ?? "";
    message.status = object.status ?? Availability_VacancyStatus.Unchecked;
    message.type = object.type ?? Availability_VacancyType.UnknownVacancyType;
    message.paymentModalities =
      object.paymentModalities !== undefined &&
      object.paymentModalities !== null
        ? PaymentModalities.fromPartial(object.paymentModalities)
        : undefined;
    message.vacancyDiff =
      object.vacancyDiff !== undefined && object.vacancyDiff !== null
        ? VacancyDifference.fromPartial(object.vacancyDiff)
        : undefined;
    message.enteringTheBoxDiff =
      object.enteringTheBoxDiff !== undefined &&
      object.enteringTheBoxDiff !== null
        ? EnteringTheBoxDifference.fromPartial(object.enteringTheBoxDiff)
        : undefined;
    message.paymentTypeList =
      object.paymentTypeList?.map((e) => PaymentInfo.fromPartial(e)) || [];
    message.tourOperatorMessages =
      object.tourOperatorMessages?.map((e) => e) || [];
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
